import React from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./firebase/AuthContext";

// Keep these lines (good for debugging API base)
import { API_BASE, DATA_BASE } from "./api/config";

console.info("[PWG startup] React bundle loaded", {
  mode: process.env.NODE_ENV,
  port: window.location.port || (window.location.protocol === "https:" ? "443" : "80"),
  dataBase: DATA_BASE || "same-origin",
  apiBase: API_BASE || "same-origin",
  firebaseEmulators: process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true",
  serviceWorker: process.env.NODE_ENV === "production" ? "enabled" : "disabled",
});

const PRODUCTION_RELEASE_BUILD = process.env.REACT_APP_PWG_PRODUCTION_RELEASE === "1";

if (PRODUCTION_RELEASE_BUILD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Service worker registration failed:", error);
    });
  });
} else if (!PRODUCTION_RELEASE_BUILD) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
      console.log("Service workers unregistered");
    });
  }

  if ("caches" in window) {
    caches.keys().then((keys) => {
      keys.filter((key) => key.startsWith("pwg-")).forEach((key) => caches.delete(key));
      console.log("PWG browser caches cleared");
    });
  }
}



const root = createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
